<template>
    <MainContentSearchable title="Listado de remitentes" id="remitentes" v-model="filters" :meta="loading ? {} : remitentes.meta" :disabled="loading" @updated="debouncedGetRemitentes">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de remitentes</h3>
            <div class="card-tools mb-3">
                <router-link :to="{ name: 'back.emails.remitentes.crear' }" class="btn btn-primary" id="crear-remitente">
                    Crear remitente
                </router-link>
            </div>
        </template>
        <template v-slot:content>
            <ContainerTable :data="remitentes.data" :responsive="esMovil">
                <b-table hover :items="remitentes.data" :fields="fields" :busy="loading" empty-text="No hay remitentes creados">
                    <template #cell(default)="{ item }">
                        <span v-if="item.default" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                        <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                    </template>
                    <template #cell(opciones)="{ item, index }">
                        <OpcionesDropdownTableComponent
                            :lastIndex="remitentes.data.length > 3 && index >= remitentes.data.length - 3"
                            :options="[
                                { to: { name: 'back.emails.remitentes.editar', params: { remitente_id: item.id }}, label: 'Editar'},
                                { type: 'action', action: () => showModal('borrar-' + item.id), label: 'Borrar' }
                            ]"
                        />
                        <BorrarModalComponent
                            confirmButton="¿Está segur@ de borrar este remitente?"
                            :name="'borrar-' + item.id"
                            :title="'Borrar remitente ' + item.nombre"
                            @close="() => closeModal('borrar-' + item.id, false)"
                            @confirm="() => eliminarRemitente(item.id)"
                        />
                    </template>
                </b-table>
            </ContainerTable>
        </template>
    </MainContentSearchable>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent';
    import OpcionesDropdownTableComponent from '@/components/backend/components/OpcionesDropdownTableComponent';

    export default {
        data() {
            return {
                loading: false,
                remitentes: {
                    data: [],
                    meta: {}
                },
                fields: [
                    { key: "nombre", label: "Nombre", class: 'text-center' },
                    { key: "email", label: "Email", class: 'text-center' },
                    { key: "default", label: "Por defecto", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
                filters: {
                    search: '',
                    per_page: 10,
                    page: 1
                }
            };
        },
        created() {
            this.getRemitentes();
            this.debouncedGetRemitentes = _.debounce(this.getRemitentes, 500);
        },
        methods: {
            async getRemitentes() {
                this.loading = true;
                try {
                    this.remitentes = await apiService.getRemitentes(this.filters);
                } catch (error) {
                    console.error('Error al obtener remitentes', error);
                } finally {
                    this.loading = false;
                }
            },
            async eliminarRemitente(id) {
                try {
                    await apiService.borrarRemitente(id);
                    this.$toast.success('Remitente eliminado correctamente');
                    this.closeModal('borrar-' + id, true)
                } catch (error) {
                    this.$toast.error(error.response?.data?.message);
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.$modal.hide(modal);
                if (creado) {
                    this.getSubscriptores();
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        components: {
            ContainerTable,
            MainContentSearchable,
            BorrarModalComponent,
            OpcionesDropdownTableComponent
        }
    };
</script>